import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmationModal =
  ({
    show = false,
    onHide = () => {},
    onConfirm = () => [],
    confirmattionKey = 0,
    confirmationMessage = "",
  }) => {
    
    return (
      <Modal key={confirmattionKey} show={show} onHide={onHide} centered>
        <Modal.Body className="d-flex justify-content-center mt-2">
          <h5>{confirmationMessage}</h5>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button variant="secondary" onClick={onHide}>
            No
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }


export default React.memo(ConfirmationModal);
